import { PARTNER_LEAD_REGISTRATION, DIRECTORY_USER } from 'pricing-pages-lib/constants/Scopes';
export const isPartnerProgramEligibleSelector = state => {
  const {
    auth: {
      user
    }
  } = state;
  if (!user) return false;
  const {
    scopes
  } = user;
  if (!scopes) return false;
  const isDirectoryUser = scopes.some(scope => scope === DIRECTORY_USER);
  const isPartner = scopes.some(scope => scope === PARTNER_LEAD_REGISTRATION);
  return isDirectoryUser && !isPartner;
};